export default __webpack_public_path__ + "07007bf67992df4f18ad0d00ab444d83.jpg";